import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Table,
  // Input,
  Button,
  Input,
  //Spinner
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { CSVExport } from "react-bootstrap-table2-toolkit"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import * as equipmentreportAction from "../../store/ZXF1aXBtZW50YXVkaXRyZXBvcnQ/actions"
import { isEmpty } from "lodash"
import { ToastContainer } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import moment from "moment"

const EquipmentAuditReport = (props) => {
  const { SearchBar } = Search
  const { dispatch, searchBtnStyle } = props

  const title = "Equipment Audit Report"

  //Export downlaod options
  const { ExportCSVButton } = CSVExport

  //Fetching API
  useEffect(() => {
    dispatch(equipmentreportAction.loadRecordsMetaData())
    dispatch(equipmentreportAction.loadEquipmentService())
  }, [])

  const update = useSelector(
    (specificstate) => specificstate.equipmentAuditReport
  )

  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
  console.log(dateFormat)
  const { equipment_service = [], recordsMetaData = {} } = update
  console.log("update is", update)

  //console.log(recordsMetaData, "recordMetaData")

  //Handle Change

  const [mode, setMode] = useState([])
  const [equipmentType, setEquipmentType] = useState([])
  const [equipmentBrand, setEquipmentBrand] = useState([])
  const [equipmentProduct, setEquipmentProduct] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)

  const [serviceData, setServiceData] = useState({
    auditFromDate: "",
    auditToDate: "",
  })

  const handleChange = (e) => {
    setServiceData({ ...serviceData, [e.target.name]: e.target.value })
  }

  console.log(recordsMetaData, "recordsMetaData")

  //Filter section
  const handleApply = () => {
    var searchMode = mode && mode.value ? mode.value : ""
    var searchType =
      equipmentType && equipmentType.value ? equipmentType.value : ""
    var searchBrand =
      equipmentBrand && equipmentBrand.value ? equipmentBrand.value : ""
    var searchProduct =
      equipmentProduct && equipmentProduct.value ? equipmentProduct.value : ""
    var searchFromDate =
      serviceData && serviceData.auditFromDate ? serviceData.auditFromDate : ""
    var searchToDate =
      serviceData && serviceData.auditToDate ? serviceData.auditToDate : ""

    var searchFilter = {}

    if (searchMode) {
      searchFilter.mode = searchMode
    }
    if (searchType) {
      searchFilter.equipmentTypeId = searchType
    }
    if (searchBrand) {
      searchFilter.equipmentBrandId = searchBrand
    }
    if (searchProduct) {
      searchFilter.productVersionId = searchProduct
    }
    if (searchFromDate) {
      searchFilter.auditFromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.auditToDate = searchToDate
    }

    dispatch(equipmentreportAction.loadEquipmentService(searchFilter))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //audit complete modal
  const [auditCompleteData, setAuditCompleteData] = useState("")
  const [auditCompleteModal, setAuditCompleteModal] = useState(false)

  //audit pending modal
  const [auditPendingData, setAuditPendingData] = useState("")
  const [auditPendingModal, setAuditPendingModal] = useState(false)

  let slNo = 0
  //const equipmentTable = []
  const equipmentTable = !isEmpty(equipment_service)
    ? equipment_service.map((data) => {
        slNo = slNo + 1

        return {
          sNo: slNo,
          _id: data._id,

          auditNo: data.auditNo,
          auditDate: data.auditDate
            ? moment(data.auditDate).format(dateFormat)
            : "",
          auditBy: data.auditName,
          auditRemarks: data.auditRemarks,
          auditCompleted: (
            <div className="d-flex">
              <span className=" badge bg-danger  rounded-circle p-2">
                {data.auditCompleted && data.auditCompleted.length > 0
                  ? data.auditCompleted.length
                  : 0}
              </span>
              <i
                className="fas fa-eye icon-btn"
                style={{
                  color: "#50a5f1",
                  marginTop: "4px",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  setAuditCompleteModal(true)
                  setAuditCompleteData(data.auditCompleted)
                }}
              ></i>
            </div>
          ),
          auditPending: (
            <div className="d-flex">
              <span className=" badge bg-danger  rounded-circle p-2">
                {data.auditPending && data.auditPending.length > 0
                  ? data.auditPending.length
                  : 0}
              </span>
              <i
                className="fas fa-eye icon-btn"
                style={{
                  color: "#50a5f1",
                  marginTop: "4px",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  setAuditPendingModal(true)
                  setAuditPendingData(data.auditPending)
                }}
              ></i>
            </div>
          ),
        }
      })
    : []
  // console.log(setAuditCompleteData)
  console.log(setAuditPendingData)
  //console.able columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      csvType: Number,
    },
    {
      dataField: "auditNo",
      text: "Audit Number",
      csvType: Number,
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "auditDate",
      text: "Audit Date",
      csvType: Number,
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "auditBy",
      text: "Audit By",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "auditRemarks",
      text: "Audit Remarks",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "auditCompleted",
      text: "Audit Completed",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "auditPending",
      text: "Audit Pending",
      csvExport: false,
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const modeOptions = [
    {
      label: "ADMIN",
      value: "ADMIN",
    },
    {
      label: "HR",
      value: "HR",
    },
    {
      label: "PHOTOGRAPHY",
      value: "PHOTOGRAPHY",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "VERMILION",
      value: "VERMILION",
    },
    {
      label: "DIVINE",
      value: "DIVINE",
    },
    {
      label: "ZG OPERATIONS",
      value: "ZG OPERATIONS",
    },
  ]

  const options = {
    sizePerPage: 10,
    //totalSize: equipment_service.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const resetFormDetails = () => {
    setMode([])
    setServiceData({
      auditFromDate: "",
      auditToDate: "",
    })
    setEquipmentBrand([])
    setEquipmentProduct([])
    setEquipmentType([])
    dispatch(equipmentreportAction.loadEquipmentService())
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Inventory"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Mode"}>
                          {"Mode"}
                        </Label>
                      </div>
                      <Select
                        name="mode"
                        value={mode}
                        onChange={(e) => setMode(e)}
                        options={modeOptions}
                        placeholder="Select Mode"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Equipment Type"}
                        >
                          {"Equipment Type"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentType"
                        value={equipmentType}
                        onChange={(e) => setEquipmentType(e)}
                        options={
                          recordsMetaData ? recordsMetaData.typeOptions : []
                        }
                        placeholder="Select Equipment"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Equipment Brand"}
                        >
                          {"Equipment Brand"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentBrand"
                        value={equipmentBrand}
                        onChange={(e) => setEquipmentBrand(e)}
                        options={
                          recordsMetaData ? recordsMetaData.brandOptions : []
                        }
                        placeholder="Select Equipment Brand"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Product Version"}
                        >
                          {"Product Version"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentProduct"
                        value={equipmentProduct}
                        onChange={(e) => setEquipmentProduct(e)}
                        options={
                          recordsMetaData ? recordsMetaData.productOptions : []
                        }
                        placeholder="Select Product Version"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Audit From Date"}
                        >
                          {"Audit From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="auditFromDate"
                        value={serviceData.auditFromDate}
                        max={serviceData.auditToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Audit To Date"}
                        >
                          {"Audit To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="auditToDate"
                        value={serviceData.auditToDate}
                        min={serviceData.auditToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => handleApply()}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetFormDetails()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={equipmentTable}
                      columns={columns}
                      search
                      // selectRow={selectRow}
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row">
                              <Col className="mb-3" md="4">
                                <div className="d-flex flex-row ">
                                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                    <div
                                      className="position-relative mt-7"
                                      style={searchBtnStyle || null}
                                    >
                                      <SearchBar {...props.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>{" "}
                              </Col>
                              <Col>
                                <ExportCSVButton
                                  className="border float-right mx-10"
                                  style={{
                                    float: "right",
                                    backgroundColor: "#e40d8c",
                                    color: "#ffffff",
                                  }}
                                  {...props.csvProps}
                                >
                                  Download{" "}
                                </ExportCSVButton>{" "}
                              </Col>
                              <Col md="12" lg="12" xl="12" sm="12" xs="12">
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  bordered={true}
                                  keyField="events"
                                  columns={columns}
                                  // expandRow={expandRow}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {auditCompleteModal && (
          <Modal size="xl" scrollable={true} show={auditCompleteModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Audit Completed
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12" className="mt-5">
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>

                      <th>Mode</th>
                      <th>Equipment Type</th>

                      <th>Equipment Brand</th>
                      <th>Product Version</th>
                      <th>Equipment Code</th>

                      <th>Serial No</th>
                      <th>Audit Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(auditCompleteData) &&
                    auditCompleteData.length > 0 ? (
                      auditCompleteData.map((item, index) => {
                        return (
                          <>
                            <tr key={item._id}>
                              <td>{index + 1}</td>

                              <td>{item.mode ? item.mode : "-"}</td>
                              <td>
                                {item.equipmentTypeName
                                  ? item.equipmentTypeName
                                  : "-"}
                              </td>
                              <td>
                                {item.equipmentBrandName
                                  ? item.equipmentBrandName
                                  : "-"}
                              </td>
                              <td>
                                {item.productVersionName
                                  ? item.productVersionName
                                  : "-"}
                              </td>
                              <td>
                                {item.equipmentCode ? item.equipmentCode : "-"}
                              </td>
                              <td>
                                {item.serialNumber ? item.serialNumber : "-"}
                              </td>

                              <td>{item.notes ? item.notes : "-"}</td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={8} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setAuditCompleteModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {auditPendingModal && (
          <Modal size="xl" scrollable={true} show={auditPendingModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Audit Pending
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12" className="mt-5">
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>

                      <th>Mode</th>
                      <th>Equipment Type</th>

                      <th>Equipment Brand</th>
                      <th>Product Version</th>
                      <th>Equipment Code</th>

                      <th>Serial No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(auditPendingData) &&
                    auditPendingData.length > 0 ? (
                      auditPendingData.map((item, index) => {
                        return (
                          <>
                            <tr key={item._id}>
                              <td>{index + 1}</td>

                              <td>{item.mode ? item.mode : "-"}</td>
                              <td>
                                {item.equipmentTypeName
                                  ? item.equipmentTypeName
                                  : "-"}
                              </td>
                              <td>
                                {item.equipmentBrandName
                                  ? item.equipmentBrandName
                                  : "-"}
                              </td>
                              <td>
                                {item.productVersionName
                                  ? item.productVersionName
                                  : "-"}
                              </td>
                              <td>
                                {item.equipmentCode ? item.equipmentCode : "-"}
                              </td>
                              <td>
                                {item.serialNumber ? item.serialNumber : "-"}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={7} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setAuditPendingModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
EquipmentAuditReport.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentAuditReport)
)
